/**
 * URL flags. Every feature that can be toggled should be reachable from here so
 * screenshots and bug reports are reproducible, e.g.
 *   ?scene=verdant&quality=high&debug=1&cam=<bookmark>&time=18
 */
const params = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');

export const flags = {
  has(name: string): boolean {
    return params.has(name);
  },
  str(name: string, fallback: string): string {
    return params.get(name) ?? fallback;
  },
  strOrNull(name: string): string | null {
    return params.get(name);
  },
  num(name: string, fallback: number): number {
    const v = params.get(name);
    if (v === null || v === '') return fallback;
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  },
  bool(name: string, fallback = false): boolean {
    const v = params.get(name);
    if (v === null) return fallback;
    return v === '' || v === '1' || v === 'true' || v === 'on' || v === 'yes';
  },
};

/** Replace (or remove, with null) a flag in the address bar without reloading. */
export function setUrlFlag(name: string, value: string | null): void {
  if (value === null) params.delete(name);
  else params.set(name, value);
  const q = params.toString();
  history.replaceState(null, '', q ? `?${q}` : location.pathname);
}
